import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { ToastProvider } from './contexts';
import './index.css';
import { routes } from './router';

// if (process.env.NODE_ENV === 'production') {
//   // eslint-disable-next-line no-console
//   console.log = () => {};
//   console.error = () => {};
//   // eslint-disable-next-line no-console
//   console.debug = () => {};
// }
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const router = createBrowserRouter(routes);
const theme = createTheme({
  typography: {
    fontFamily: 'AvenirRoman, sans-serif',
  },

  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          lineHeight: '150%',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#036272',
          },
          '&:hover,&.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#036272',
            },
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          height: '100%',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          height: '100%',
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#B4001D',
    },
  },
});

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <ToastProvider>
        <CssBaseline />
        <RouterProvider
          router={router}
          fallbackElement={<div>Loading...</div>}
        />
      </ToastProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// reportWebVitals();
